import React, { useState } from 'react'
import { CButton, CCard, CCardBody, CCol, CFormInput, CRow } from '@coreui/react'
import { Table } from 'antd'
import { wtApiCall } from 'src/helpers/commons/ApiWrapper'
import { lzNotifyErrorMessageFromResult } from 'src/helpers/commons/notifications'
import { wtFormatRoundedValue } from 'src/helpers/commons/utils'

const formatDate = (value) => (value ? String(value).slice(0, 10) : '-')

export default function ShootingMonthlyInvoiceReport() {
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [reportData, setReportData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const loadReport = () => {
    setIsLoading(true)
    wtApiCall(
      'reports/shooting_monthly_invoice_report',
      { from_date: fromDate, to_date: toDate },
      'get',
      (response) => {
        setReportData(response.data || [])
        setIsLoading(false)
      },
      (error) => {
        setIsLoading(false)
        lzNotifyErrorMessageFromResult(error)
      },
    )
  }

  const columns = [
    { title: 'Invoice No', dataIndex: 'invoice_no', key: 'invoice_no' },
    { title: 'Invoice Date', key: 'invoice_date', render: (row) => formatDate(row.invoice_date) },
    { title: 'Member ID', dataIndex: 'member_id', key: 'member_id' },
    { title: 'Member', key: 'member', render: (row) => row.member?.name || '-' },
    { title: 'Period', key: 'period', render: (row) => `${row.invoice_month}/${row.invoice_year}` },
    { title: 'Shooting Total', key: 'shooting_total', render: (row) => wtFormatRoundedValue(row.shooting_total || 0, '', '', 2) },
    { title: 'Membership Fee', key: 'membership_fee_amount', render: (row) => wtFormatRoundedValue(row.membership_fee_amount || 0, '', '', 2) },
    { title: 'Arrears', key: 'arrears_total', render: (row) => wtFormatRoundedValue(row.arrears_total || 0, '', '', 2) },
    { title: 'Paid Amount', key: 'paid_amount', render: (row) => wtFormatRoundedValue(row.paid_amount || 0, '', '', 2) },
    { title: 'Grand Total', key: 'grand_total', render: (row) => wtFormatRoundedValue(row.grand_total || 0, '', '', 2) },
  ]

  return (
    <div style={{ padding: '2%' }}>
      <h4 className="text-center">Shooting Monthly Invoice Report</h4>
      <CCard className="card-dark">
        <CCardBody>
          <CRow className="g-3 align-items-end mb-3">
            <CCol md={3}><label>From Date</label><CFormInput type="date" value={fromDate} onChange={(event) => setFromDate(event.target.value)} /></CCol>
            <CCol md={3}><label>To Date</label><CFormInput type="date" value={toDate} onChange={(event) => setToDate(event.target.value)} /></CCol>
            <CCol md={2}><CButton color="primary" className="text-white" onClick={loadReport}>Load Report</CButton></CCol>
          </CRow>
          <Table rowKey="id" columns={columns} dataSource={reportData} loading={isLoading} pagination={{ pageSize: 25, showSizeChanger: true }} scroll={{ x: 1200 }} />
        </CCardBody>
      </CCard>
    </div>
  )
}
